import styled from 'styled-components';
import {
  StrictTruncatedTextContent,
  TruncatedTextContent,
} from '../../utils/formatters';
import {
  getTableColumnMaxWidth,
  mobileMediaQuery,
  tableMediaQuery,
} from '../../utils/responsive';
import ItemsTable, { TableToolbar } from './ItemsTable';

const StyledTable = styled(ItemsTable)`
  width: 100%;
  max-width: 1200px;
  border: none;
  table {
    width: 100%;
    border: none;
    margin-bottom: 0;
    padding-bottom: 1rem;
  }
  ${TableToolbar} {
    padding: 24px 8px 16px;
  }
  th {
    width: 100%;
    border: none;
    padding: var(--cell-padding);
  }
  td {
    padding: 14px var(--cell-padding);
    border-right: none;
    color: var(--text-muted-color);
    ${({ multiselectButton }) => `&:nth-child(${
      multiselectButton ? '2' : '1'
    }) {
      color: var(--text-color);
      font-weight: 500;
    }}`}
    ${TruncatedTextContent} {
      ${({ cols }) =>
        `@media ${tableMediaQuery} {
          max-width: ${getTableColumnMaxWidth(cols.length)};
        }`}
    }
  }
  ${StrictTruncatedTextContent} {
    width: var(--table-column-width);
  }
  td > a:hover {
    color: var(--text-muted-color);
  }
  @media ${mobileMediaQuery} {
    margin-bottom: 0;
    tr {
      width: calc(100vw - (2 * var(--content-x-padding)));
      display: flex;
      justify-content: space-between;
    }
    td,
    th {
      min-width: auto;
      &:first-of-type {
        flex-shrink: 1;
        flex-grow: 1;
        overflow: hidden;
      }
      &:last-of-type {
        text-align: right;
      }
      ${TruncatedTextContent} {
        min-width: var(--table-column-width);
      }
    }
  }
`;

const LineItemsTable = (props) => {
  const { cols } = props;
  return (
    <StyledTable isLineTable cols={cols} {...props} $numCols={cols?.length} />
  );
};

export default LineItemsTable;
